import { TFunction } from 'i18next';

import { allNavigationItems, NavigationItem } from './items';
import { GlobalEvaluationsContextValue } from 'src/context/GlobalEvaluationsContext';

interface GetAuthorizedNavigationItems {
  can: GlobalEvaluationsContextValue['can'];
  t: TFunction<any>;
}

interface NavigationItemWithTranslation extends Omit<NavigationItem, 'tKey'> {
  title: string;
}

export const getAuthorizedNavigationItems = ({
  can,
  t,
}: GetAuthorizedNavigationItems) => {
  const authorizedNavigationItems = allNavigationItems.filter(
    ({ requires }) => {
      const { action, resource } = requires;
      return can({ action: action.name, resource: resource.type });
    },
  );

  const authorizedNavigationItemsWithTranslation: NavigationItemWithTranslation[] =
    authorizedNavigationItems.map(({ tKey, ...props }) => {
      return {
        ...props,
        title: t(tKey),
      };
    });

  return authorizedNavigationItemsWithTranslation;
};
